import { render, staticRenderFns } from "./QuizStudentDashboard.vue?vue&type=template&id=3117b337&"
import script from "./QuizStudentDashboard.vue?vue&type=script&lang=js&"
export * from "./QuizStudentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./QuizStudentDashboard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QuizStudentDashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports